<template>
  <div>
    <h2><router-link :to="{ name: 'admin-design-survey' }">Design</router-link> - Edit {{ activeField.title }}</h2>
    <tabs cache-lifetime="0" @changed="handleTabChange($event)">
      <tab name="Basic Info">
        <vue-form-generator
          :schema="buildSchema('field', 'fieldSchema', 'basicInfo', 'edit')"
          :model="formModel"
          :options="formOptions"
          class="vue-form-generator--admin">
        </vue-form-generator>
      </tab>
      <tab name="Validation" v-if="fieldHasInputBox(formModel.field_type)">
        <vue-form-generator
          :schema="buildSchema('field', 'fieldSchema', 'validation', 'edit')"
          :model="formModel"
          :options="formOptions"
          class="vue-form-generator--admin">
        </vue-form-generator>
      </tab>
      <tab name="Field Options" v-if="fieldHasOptions(formModel.field_type)">
        <vue-form-generator
          :schema="buildSchema('field', 'fieldSchema', 'fieldOptions', 'edit')"
          :model="objects[activeObject]"
          :options="formOptions"
          class="vue-form-generator--admin">
        </vue-form-generator>

        <div class="list-view list-view--inline" v-if="objects.length > 1">
          <div class="list-view__header">
            <div>Text</div>
            <div>Position</div>
            <div>Actions</div>
          </div>

          <div class="list-view__row" v-for="(fieldOption, index) in objects" v-if="index > 0">
            <div>{{ fieldOption.text }}</div>
            <div>{{ fieldOption.position }}</div>
            <div>
              <button
                class="icon-button actions__action"
                @click="alterPosition(fieldOption.id, fieldOption.position - 1)"
                v-if="index !== 1">
                  <i class="material-icons">arrow_upward</i>
              </button>
              <button
                class="icon-button actions__action"
                @click="alterPosition(fieldOption.id, fieldOption.position + 1)"
                v-if="index !== objects.length - 1">
                  <i class="material-icons">arrow_downward</i>
              </button>
              <template v-if="fieldOption.id">
                <button class="icon-button" @click="editObject(index)"><i class="material-icons">mode_edit</i></button>
                <button class="icon-button" @click="deleteObject(fieldOption)"><i class="material-icons">delete</i></button>
              </template>
            </div>
          </div>
        </div>
      </tab>
    </tabs>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import editForm from '@/mixins/edit-form';
  import inlineEditForm from '@/mixins/inline-edit-form';

  export default {
    name: 'admin-edit-field',
    mixins: [editForm, inlineEditForm],

    data: () => {
      return {
        formIndex: 'admin-design-survey',
        formName: 'Field',
        inlineName: 'FieldOption',
        inlineId: 'options',
      };
    },

    computed: {
      ...mapGetters('admin', [
        'activeField',
      ]),

      ...mapGetters([
        'fieldHasOptions',
        'fieldHasInputBox',
      ]),

      formParentQuery() {
        return { key: 'page', value: this.activeField.page_id };
      },
    },

    watch: {
      activeField: {
        handler() {
          this.defineFormObjects();
          this.setupObjects();
        },
        deep: true,
      },
    },

    methods: {
      alterPosition(fieldOptionId, position) {
        this.$store.dispatch('admin/editFieldOption', { data: { id: fieldOptionId, position }, noCommit: true })
          .then(() => this.$store.dispatch('admin/fetchFieldOptions', this.activeField.id));
      },
    },
  };
</script>
